function fn_layout_main() {
    var body = $("body");

    setTimeout(function () {
        body.removeClass("preload").addClass("loaded");
        setTimeout(function () {
            body.removeClass("loaded");
        }, 500);
    }, 300);

    $(".elm_pdf_inner").find("embed").parent().on("click", function(){
        window.location.href = $(this).find("embed").attr("src");
    });
    if(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
        $(".elm_pdf_inner").find("embed").parent().addClass("ios");
    }

    $(window).scroll(function () {

        var visual = $('#visual');
        var scroll = $(window).scrollTop();



        if (visual.length) {
            var scroll_height = $('#visual').height() - $('.header').height() - 100;
        } else {
            var scroll_height = 0;
        }

        var scrolled_header = $("#scrolled_header");

        if (!scrolled_header.hasClass("active")) {
            if (scroll >= scroll_height) {
                scrolled_header.addClass("scrolled");//.addClass("blue").removeClass("orange");
            } else {
                scrolled_header.removeClass("scrolled");//.removeClass("blue").addClass("orange");
            }
        }

        if (scroll == 0) {
            scrolled_header.removeClass("scrolled");
        }



        var element = $(body.find('[data-header-color]'));
        var scroll_top = $(document).scrollTop() + 200;

        element.each(function () {

            var el = $(this),
                    color = el.data("header-color");

            if (el.position().top <= scroll_top && el.position().top + el.height() >= scroll_top) {
                scrolled_header.removeClass("blue orange green");
                scrolled_header.addClass(color);

                scrolled_header.find(".button").removeClass("button-orange button-green button-blue");
                scrolled_header.find(".button").addClass("button-" + color);
            }
        });



    });


    var pull = $('#pull .pull_menu');
    var menu = $('.menu');
    var header = $('.header');
    var actual_page = $('#actual_page');
    var actual_page_text = actual_page.text();

    $(pull).on('click', function (e) {
        e.preventDefault();
        menu.stop().slideToggle("slow");
        pull.find(".bind--menu-toggle").toggleClass("open");
        header.toggleClass('active');

        if (actual_page.text() == "Close") {
            actual_page.text(actual_page_text);
        } else {
            actual_page.text("Close");
        }

        return false;
    });

    var has_submenu = $('.has_submenu');

    if (has_submenu && $(window).width() < 991) {
        has_submenu.on("click touch", function (e) {
            e.preventDefault();
            var $this = $(this);
            if($this.parent("li").hasClass("mod--focus")){
                $this.parent("li").removeClass("mod--focus");
                $this.next(".submenu").removeClass("mod--focus");
            }
            else {
                $(".submenu.mod--focus").removeClass("mod--focus");
                $("li.mod--focus").removeClass("mod--focus");
                $this.parent("li").addClass("mod--focus");
                $this.next(".submenu").addClass("mod--focus");
            }
        })
    }

    $('.select-lang > span').on('click', function (e) {
        e.preventDefault();

        $('.select-lang-inner').stop().slideToggle("150");
        $('.select-lang').toggleClass("active");

        return false;
    });

    $(window).on('scroll',function(){
        if ($('.select-lang').hasClass("active")) {
            $('.select-lang-inner').stop().slideToggle("150");
            $('.select-lang').toggleClass("active");
        }
    });


    $('.booking-tablet, .booking-button').on('click', function (e) {
        e.preventDefault();

        var bookingUrl = $(this).data('booking-url');
        var bookDetail = "";

        if ($(this).hasClass("button-orange")) {
            //pokoje
            bookDetail = "";

        } else if ($(this).hasClass("button-blue")) {
            //wellness
            bookDetail = "?preferpackage=49";
        } else if ($(this).hasClass("button-green")) {
            //lecba
            bookDetail = "?preferpackage=1";
        }

        window.location.replace(bookingUrl + bookDetail);

        return false;
    });

    //Open popUp procedure
    $('.procedures a').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var procedure_popup_id = $(this).data("attr-open-frame");
        ShowPopup(procedure_popup_id);
        window.history.pushState("", "", '' + "?procedure=" + procedure_popup_id);
    });

    /*if ($(".popup-window".length)) {
        $("html").on("click", function (e) {
            if ($(e.target).closest('.popup-window').length === 0 && !$(".datepicker").hasClass("active")) {
                window.history.pushState("", "", removeURLParameter(window.location.href, 'procedure'));
                $('.popup-window').fadeOut();
                $('.popup').fadeOut();

                setTimeout(function () {
                    $('.popup-window').removeClass('small');
                    $('.popup-window').removeClass('fixed');
                }, 800);
            }
        });
    }*/

    $(".close, .popup").click(function (e) {
        e.preventDefault();
        window.history.pushState("", "", removeURLParameter(window.location.href, 'procedure'));
        $('.popup-window').fadeOut();
        $('.popup').fadeOut();
        $("body").css("overflow","auto");


        setTimeout(function () {
            $('.popup-window').removeClass('small');
            $('.popup-window').removeClass('fixed');
        }, 800);

        return false;
    });




    $(document).on("scroll", menu_scroll);
    function menu_scroll() {
        var $offset = 50;
        var $scroll = $(document).scrollTop() + $offset;
        var $this = $("#content");

        var $set = $this.find(".scroll-listener");
        var len = $set.length;
        console.log("len - " + len);

        $this.find(".scroll-listener").each(function () {

            var $el = $(this),
                    $index = $el.data("index"),
                    $nav = $this.find(".side-list [data-index]"),
                    $nav_index = $this.find(".side-list [data-index=" + $index + "]");

            var move = 700;
            if ($index == 5) {
                var move = 300;
            }
            if ($el.position().top + move <= $scroll && $el.position().top + $el.height() > $scroll && !$nav_index.hasClass("active")) {
                $nav.removeClass("active");
                $nav_index.addClass("active");
            }

        });
    }


    /*remove ? from url addres when closing*/
    function removeURLParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0; ) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            return url;
        } else {
            return url;
        }
    }
    ;

    /*Open popup when send link*/
    if (urlParam('procedure') > 0) {
        console.log("Open popup when send link");
        var procedure_popup_id = urlParam('procedure');
        ShowPopup(procedure_popup_id);
    }

    function urlParam(name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        } else {
            return results[1] || 0;
        }
    }
    ;


    var $big_img_1 = $('#big-img-1');
    var $big_img_2 = $('#big-img-2');


    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
        if ($big_img_1.length && $big_img_2.length) {
            $big_img_1.addClass("active");
            $big_img_2.addClass("active");

            $(window).scroll(function () {
                $big_img_1.css({
                    'top': -($(this).scrollTop() / 9) + "px"
                });

                $big_img_2.css({
                    'top': -($(this).scrollTop() / 10) + "px"
                });

            });
        }
    }


    var $lg = $('.gallery-bind');

    if ($lg.length) {
        $lg.each(function () {
            var $el = $(this);
            var gallery_data = $el.find("[data-gallery]").data("gallery");
            if($.isArray(gallery_data)){
                $el.on("click","a",function (e) {
                    e.preventDefault();
                    $(this).lightGallery({
                        hash: false,
                        dynamic: true,
                        dynamicEl: gallery_data
                    })
                });
            }
            else {
                $el.lightGallery({
                    hash: false
                });
            }
        })
    }


    var side_list = $('.side-list');

    if (side_list.length) {
        var side_list_height = side_list.height();
        side_list.parent().css({
            "min-height": side_list_height
        });
    }

    $('a.read-more').click(function (event) {
        event.preventDefault();
        $(this).parent().find('.more-text').slideToggle();
        //$("#content").data("lng-less");
        //$("#content").data("lng-more");
        var text = $(this).text();
        $(this).text(
                text == $("#content").data("lng-less") ? ("#content").data("lng-more") : $("#content").data("lng-less"));
    });

    var $grid = $('.gallery--grid').imagesLoaded(function () {
        $grid.masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-item'
        });
    });


    var $side_list_on_page = $('.side-list');

    if ($side_list_on_page.length) {
        $(window).scroll(function (e) {
            var $el = $('.side-list');
            var $elPos = $('.pos_relative').offset();
            var isPositionFixed = ($el.css('position') == 'fixed');
            var $footer = $('#main_footer').offset().top;

            if ($(this).scrollTop() > $elPos.top - 150 && !isPositionFixed) {
                $el.css({'position': 'fixed', 'top': '150px'});
            }
            if ($(this).scrollTop() < $elPos.top - 150 && isPositionFixed)
            {
                $el.css({'position': 'absolute', 'top': '0px'});
            }
            console.log($footer);
            if (($(this).scrollTop() + $el.outerHeight() + 150) > $footer) {
                $el.css({'position': 'absolute', 'top': '0px'});
            }
        });

        $(document).on("scroll", onScroll);
    }
    var $dnes = new Date();
    var $zitra = new Date();
    $zitra.setDate($zitra.getDate() + 1);

    $('#check_in').attr("readonly","true");
    $('#check_out').attr("readonly","true");

    var $check_in = $('#check_in').datepicker({
        minDate: $dnes,
        language: $("html").attr("lang"),
        autoClose: true,
        altField: $("#check_in_data"),
        altFieldDateFormat: "yyyy-mm-dd",
        onSelect: function(formattedDate, date, inst){
            var $datum = new Date(date);
            $datum.setDate($datum.getDate() + 1);
            $check_out.update({
                minDate: $datum
            })
        }
    }).data('datepicker');

    var $check_out = $('#check_out').datepicker({
        minDate: $zitra,
        language: $("html").attr("lang"),
        autoClose: true,
        altField: $("#check_out_data"),
        altFieldDateFormat: "yyyy-mm-dd",
        position: "top left",
        onSelect: function(formattedDate, date, inst){
            var $datum = new Date(date);
            $datum.setDate($datum.getDate() - 1);
            $check_in.update({
                maxDate: $datum
            })
        }
    }).data('datepicker');

    $("a[href='#content']").click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                || location.hostname == this.hostname) {

            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 115
                }, 1500);
                return false;
            }
        }
    });

    $("[data-pdf-switch]").nl_switch();


    var $map = $('#map-canvas');
    if ($map.length) {
        $.getScript("https://maps.googleapis.com/maps/api/js") //ADD GOOGLE KEY HERE
                .done(function () {
                    //--- GOOGLE MAP --- //
                    var coords = $map.data('coords').split(/[\s,]+/);
                    var mapOptions = {
                        zoom: 13, scrollwheel: false, draggable: false, mapTypeControl: false, center: {
                            lat: parseFloat(coords[0]), lng: parseFloat(coords[1])
                        }
                    };
                    var map = new google.maps.Map($map[0], mapOptions);
                    var marker_s = new google.maps.Marker({
                        position: mapOptions.center, map: map, title: $map.data('title'), icon: '/img/marker.png' // marker main hotel
                    });

                    var marker = new google.maps.Marker({
                        title: $map.data('title'), icon: '/img/marker.png'
                    });

                    google.maps.event.addListener(map, 'click', function () {
                        map.setOptions({
                            scrollwheel: true, draggable: true
                        });
                    });

                    $('[data-gps]').each(function () {
                        var $this = $(this),
                                positionArr = $this.data('gps').split(/[\,\s]+/),
                                position = new google.maps.LatLng(parseFloat(positionArr[0]), parseFloat(positionArr[1])),
                                position_s = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]));
                        $this.click(function (e) {

                            e.preventDefault();
                            if ($(this).hasClass('active')) {
                                $(this).removeClass('active');
                                marker.setMap(null);
                                map.panTo(position_s);
                            } else {
                                $("[data-gps]").removeClass('active');
                                $(this).addClass('active');
                                map.panTo(position);
                                marker.setMap(map);
                                marker.setPosition(position);
                                //marker.setTitle($this.attr("title"));
                            }
                            if ($(window).width() < 960) {
                                $('html, body').animate({
                                    scrollTop: $this.closest("#location").offset().top - 80
                                }, 800);
                            }
                        });
                    });
                });
    }



}//main layout




function onScroll(event) {
    var scrollPosition = $(document).scrollTop();
    $('.side-list li a').each(function () {
        var currentLink = $(this);
        var refElement = $(currentLink.attr("href"));
        if (refElement.position().top <= (scrollPosition + 100) && refElement.position().top + refElement.height() > (scrollPosition + 100)) {
            $('.side-list li').removeClass("active");
            currentLink.parent().addClass("active");
        } else {
            currentLink.parent().removeClass("active");
        }
    });
}
if ($("#comp-contact").length) {
    //alert("spam block");
    setTimeout(function () {
        $("#comp-contact").append('<input name="antispam" value="antispam" type="hidden" />');
    }, 2500);
}
